import AbstractReactBehaviour from "../behaviours/abstract-react-behaviour";

require("../../scss/app-cabins.scss");

import Application from "./application";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import StickyNavBehaviour from "../behaviours/sticky-nav-behaviour";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ModalPartial from "../jsx/modal/modal-partial";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import AccordionBehaviour from "../behaviours/accordion-behaviour";
import ReadMoreBehaviour from "../behaviours/read-more-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";
import TabsBehaviour from "../behaviours/tabs-behaviour";
import HashBehaviour from "../behaviours/hash-behaviour";
import ScrollToBehaviour from "../behaviours/scroll-to-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import VideoModal from "../jsx/modal/video-modal";
import VirtualTourModal from "../jsx/modal/virtual-tour-modal";
import ImageModal from "../jsx/modal/image-modal";
import Gallery from "../jsx/gallery";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";

let config = {};
config.behaviours = {
    'HideShowBehaviour': new HideShowBehaviour(),
    'StickyNavBehaviour': new StickyNavBehaviour(),
    'MobileMenuBehaviour': new MobileMenuBehavior(),
    'EqualizeBehaviour': new EqualizeBehavior(),
    'AccordionBehaviour': new AccordionBehaviour(),
    'ReadMoreBehaviour': new ReadMoreBehaviour(),
    'TabsBehaviour': new TabsBehaviour(),
    'HashBehaviour': new HashBehaviour(),
    'ScrollToBehaviour': new ScrollToBehaviour(),
    'ToggleClassBehaviour': new ToggleClassBehavior(),
    'CarouselBehavior': new CarouselBehaviour(),
    'BlockEventBehaviour': new BlockEventBehaviour(),
};
config.components = {
    'modal-partial': ModalPartial,
    'shortlist-count': ShortlistCount,
    'shortlist-button': ShortlistButton,
    'video-modal': VideoModal,
    'virtual-tour-modal': VirtualTourModal,
    'image-modal': ImageModal,
    'gallery': Gallery,
};

new Application(config);